import React from "react";

const Services = () => {
  return (
    <section
      id="services-overview"
      className="services-overview"
      aria-labelledby="services-heading"
    >
      <div className="services-intro">
        <p className="section-kicker">How we can help</p>
        <h2 id="services-heading" className="feature-heading">
          Practical technology for the work behind the mission.
        </h2>
        <p className="feature-text">
          From a first website to a connected digital operating environment,
          BizDeploy helps your team choose, implement, and manage the technology
          that makes everyday work easier.
        </p>
      </div>

      <div className="service-lanes">
        <a href="#technologies" className="service-lane">
          <span className="service-lane-number">01</span>
          <span className="service-lane-content">
            <strong>AI implementation and automation</strong>
            <span>
              Customer support, internal knowledge, and repeatable workflows
              that give your team time back.
            </span>
          </span>
          <span className="service-lane-arrow" aria-hidden="true">
            ↗
          </span>
        </a>
        <a href="#contact" className="service-lane">
          <span className="service-lane-number">02</span>
          <span className="service-lane-content">
            <strong>Managed digital operations</strong>
            <span>
              Websites, productivity platforms, security, backups, and the
              practical support around them.
            </span>
          </span>
          <span className="service-lane-arrow" aria-hidden="true">
            ↗
          </span>
        </a>
        <a href="#wix-migration" className="service-lane">
          <span className="service-lane-number">03</span>
          <span className="service-lane-content">
            <strong>Purpose-built software and systems</strong>
            <span>
              Digital products and connected tools shaped around how your
              organisation actually works.
            </span>
          </span>
          <span className="service-lane-arrow" aria-hidden="true">
            ↗
          </span>
        </a>
      </div>
    </section>
  );
};

export default Services;
